// extracted by mini-css-extract-plugin
module.exports = {"modal":"_62b375f","okButton":"fd86282"};